import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { environment } from '../../../../environments/environment';
import * as fromDataServices from '../../../data-services';
import { Message } from '../../../shared';
import { DisplayErrors } from '../../../shared/errors-sidenav/DisplayErrors';
@Component({
    selector: 'ef-indirect-rate-review-presenter',
    templateUrl: './indirect-rate-review-presenter.component.html',
    styleUrls: ['./indirect-rate-review-presenter.component.scss'],
    standalone: false
})
export class IndirectRateReviewPresenter
    extends DisplayErrors<fromDataServices.IndirectRateReview.IndirectRateReviewModel>
    implements OnInit {
    numCols = 9;
    dropdownItemHeight = environment.dropdownItemHeight;
    moment: any;
    @Input() loading = false;
    @Input() messages: Message[];
    @Output() Cancel = new EventEmitter();
    @Output() Commit = new EventEmitter();

    cancelDisabled: boolean = false;
    commitDisabled: boolean = false;
    constructor() {
        super();
        this.moment = moment;
    }
    cols = [
        { field: 'Contract Type', header: 'Contract Type' },
        { field: 'Contract', header: 'Contract' },
        { field: 'Task', header: 'Task' },
        { field: 'PeriodStart', header: 'PeriodStart' },
        { field: 'PeriodEnd', header: 'PeriodEnd' },
        { field: 'Cost Center', header: 'Cost Center' },
        { field: 'Expense Type', header: 'Expense Type' },
        { field: 'Service Item', header: 'Service Item' },
        { field: 'TaskListID', header: 'TaskListID' },
        { field: 'Hours', header: 'Hours' },
        { field: 'Amount', header: 'Amount' },
        { field: 'FR Burden', header: 'FR Burden' },
        { field: 'OH Burden', header: 'OH Burden' },
        { field: 'Handling Burden', header: 'Handling Burden' },
        { field: 'GA Burden', header: 'GA Burden' },
        { field: 'Before Fee', header: 'Before Fee' },
        { field: 'Fee Burden', header: 'Fee Burden' },
        { field: 'Burdened Amount', header: 'Burdened Amount' }
    ];

    ngOnInit(): void {}
    onDownload(): void {
        this.dataTable.exportCSV();
    }
}
